import EFPic from '@/components/UI/EFPic';
import EFDownload from '@/components/UI/svg/CSR/Icons/EFDownload';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import css from './index.module.scss';

export default function E() {
    const { useLang, useEffect, Link } = useGlobal();
    const { t } = useLang('csr');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // img旋转动画
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_E .stickyBox .imgBox',
            triggerHook: 1,
            offset: 0,
            duration: 600,
        })
            .setTween(TweenMax.to('.csr_h5_E .stickyBox .img', 0.5, { css: { transform: 'rotate(0deg)', scale: 1, top: 0 } }))
            .addTo(controller);

        // 文字（标题、副标题）动画
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_E .text',
            triggerHook: 1,
            offset: -100,
        })
            .setClassToggle('.csr_h5_E .titleBox', 'enter')
            .addTo(controller);

        // btn动画
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_E .supperBox .btn',
            triggerHook: 1,
            offset: 240,
        })
            .setClassToggle('.csr_h5_E .supperBox .btn', 'enter')
            .addTo(controller);
    }, []);
    const letters: [string] = t('secE_title').split('');

    return (
        <div className={`csr_h5_E ${css.csr_h5_E}`}>
            <div className="innerBox">
                <div className="upperBox">
                    <div className="stickyBox">
                        <div className="imgBox">
                            <div className="img">
                                <EFPic src={['/img/csr/h5/5.jpg', '/img/csr/h5/5.webp']} alt={t('secE_title')} aria-label={t('secE_title')} />
                            </div>
                        </div>
                        <div className="titleBox">
                            <div className="title">
                                {letters?.map((letter: string, k: number) => (
                                    <span key={k} className={`letter_e letter_${k}`}>
                                        {letter}
                                    </span>
                                ))}
                            </div>
                            <div className="subTitle">{t('secE_subTitle')}</div>
                        </div>
                    </div>
                </div>
                <div className="supperBox">
                    <p className="text">{t('secE_text')}</p>
                    <Link className="btn" href={`/download?url=${encodeURIComponent('https://websiteoss.ecoflow.com/pdf/handbook_compressed.pdf')}`} target="_blank">
                        <span className="btnText">{t('secE_download')}</span>
                        <span className="icon">
                            <EFDownload />
                        </span>
                    </Link>
                </div>
            </div>
        </div>
    );
}
